"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactLive = require("react-live");

var _liveMarkdown = _interopRequireDefault(require("./liveMarkdown.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var LiveMarkdown =
/*#__PURE__*/
function (_React$Component) {
  _inherits(LiveMarkdown, _React$Component);

  function LiveMarkdown(props) {
    var _this;

    _classCallCheck(this, LiveMarkdown);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(LiveMarkdown).call(this, props));
    _this.state = {
      expanded: false,
      content: props.content
    };
    return _this;
  }

  _createClass(LiveMarkdown, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          attributes = _this$props.attributes,
          scope = _this$props.scope;
      var _this$state = this.state,
          content = _this$state.content,
          expanded = _this$state.expanded;
      return _react["default"].createElement("div", {
        className: _liveMarkdown["default"]['live-markdown']
      }, _react["default"].createElement(_reactLive.LiveProvider, {
        code: content,
        scope: scope
      }, _react["default"].createElement("div", {
        className: _liveMarkdown["default"]['live-markdown-preview']
      }, _react["default"].createElement(_reactLive.LivePreview, null)), expanded && _react["default"].createElement("div", {
        className: _liveMarkdown["default"]['live-markdown-editor']
      }, _react["default"].createElement(_reactLive.LiveEditor, null)), _react["default"].createElement(_reactLive.LiveError, null), attributes.interactive === 'true' && _react["default"].createElement("div", {
        className: _liveMarkdown["default"]['live-markdown-editor-toggle'],
        onClick: function onClick() {
          return _this2.setState({
            expanded: !expanded
          });
        },
        title: expanded ? 'Hide Code' : 'Show Code'
      }, expanded ? '</>' : '< >')));
    }
  }]);

  return LiveMarkdown;
}(_react["default"].Component);

LiveMarkdown.propTypes = {
  attributes: _propTypes["default"].shape({
    interactive: _propTypes["default"].string
  }),
  content: _propTypes["default"].string,
  scope: _propTypes["default"].object
};
LiveMarkdown.defaultProps = {
  attributes: {
    interactive: 'true'
  },
  content: '',
  scope: {}
};
var _default = LiveMarkdown;
exports["default"] = _default;